module.exports = __webpack_public_path__ + "fonts/Lexend-ExtraLight.d523700.woff2";